export const documentsRequiredView = {
    event: "Documents_required_view",
    eventCategory: "sell_car_homepage",
    eventAction: "Documents_required_view",
    eventLabel: "Documents required to sell used cars online? | view"
};

export const tipsToSellView = {
    event: "tips_to_sell_view",
    eventCategory: "sell_car_homepage",
    eventAction: "tips_to_sell_view",
    eventLabel: "Tips to sell used cars | view"
};

export const motivatesUsView = {
    event: "motivates_us_view",
    eventCategory: "sell_car_homepage",
    eventAction: "motivates_us_view",
    eventLabel: "What motivates us | view"
};

export const motivatesUsForwardArrow = {
    event: "motivates_us_forward_arrow",
    eventCategory: "sell_car_homepage",
    eventAction: "motivates_us_forward_arrow",
    eventLabel: "What motivates us | Forward arrow click"
};

export const motivatesUsBackArrow = {
    event: "motivates_us_back_arrow",
    eventCategory: "sell_car_homepage",
    eventAction: "motivates_us_back_arrow",
    eventLabel: "What motivates us | back arrow click"
};

export const motivatesUsDownloadCta = {
    event: "motivates_us_download_cta",
    eventCategory: "sell_car_homepage",
    eventAction: "motivates_us_download_cta",
    eventLabel: "What motivates us | Google Play/App Store/Trustpilot click"
};

export const wayToSellView = {
    event: "way_to_sell_view",
    eventCategory: "sell_car_homepage",
    eventAction: "way_to_sell_view",
    eventLabel: "The simplest way to sell! | view"
};

export const getCarPriceInPageCTA = {
    event: "get_car_price_in_page_cta",
    eventCategory: "homepage_dweb",
    eventAction: "get_car_price_in_page_clicked"
};

export const sellCarNowInPageCTA = {
    event: "sell_car_now_in_page_cta",
    eventCategory: "homepage_dweb",
    eventAction: "sell_car_now_in_page_clicked"
};

export const popularCityTextClick = {
    event: "popular_city_text_click",
    eventCategory: "homepage_dweb",
    eventAction: "popular_city_clicked"
};

export const getCarPriceBottom =  {
    eventCategory: "homepage_dweb",
    event: "get_car_price_bottom",
    eventAction: "Get car price bottom CTA"
};
